/* exported ON_CHANGE_DEBOUNCE_TIMER */
// eslint-disable-next-line no-redeclare
const ON_CHANGE_DEBOUNCE_TIMER = 300;

/* exported PUB_SUB_EVENTS */
// eslint-disable-next-line no-redeclare
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
